var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowSlider = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 45,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.503 38.987 10.71 22.157l16.793-16.83-5.17-5.17-22 22 22 22 5.17-5.17Z"
})));
export { SvgArrowSlider as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCAyOCA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3LjUwMzQgMzguOTg3M0wxMC43MSAyMi4xNTczTDI3LjUwMzQgNS4zMjcyOUwyMi4zMzM0IDAuMTU3Mjg3TDAuMzMzMzU5IDIyLjE1NzNMMjIuMzMzNCA0NC4xNTczTDI3LjUwMzQgMzguOTg3M1oiIC8+Cjwvc3ZnPgo=";